export default __webpack_public_path__ + "static/media/logo.9f4cc766.png";